<template>
  <v-row>
    <v-col class="text-center">
      <v-btn class="ma-2" tile outlined color="primary" @click="save(path)">
        <v-icon left>settings</v-icon>{{$t('Networks.save')}}
      </v-btn>
    </v-col>
    <v-col class="text-center">
      <v-btn class="ma-2" tile outlined color="primary" @click="$emit('back')">
        <v-icon left>mdi-arrow-left</v-icon>{{$t('Networks.back')}}
      </v-btn>
    </v-col>
  </v-row>
</template>

<script>
import axios from "axios";
import tokenStore from "../../store/TokenStore";

export default {
  props: {
    path: String,
    networkToCreate: Object,
    networkToUpdate: Object,
    networkId: String
  },
  methods: {
    save: function(path) {
      switch (path) {
        case "create":
          if (this.networkToCreate.valid) {
            console.log( this.networkToCreate);
            axios
              .post(
                process.env.VUE_APP_API_ADDR + "/api/network",
                this.networkToCreate,
                {
                  headers: { Authorization: tokenStore.getToken() }
                }
              )
              .then(res => {
                if (res.data.success) {
                  this.$emit("saved", this.$t('Networks.Alert.success-create'));
                }
              })
              .catch(err => {
                console.log(err);
                this.$emit("error", err.response.data.errorMessage);
              });
          } else {
            this.$emit("error", this.$t('Networks.Alert.form-error'));
          }
          break;
        case "edit":
          if (this.networkToUpdate.valid) {
            axios
              .put(
                process.env.VUE_APP_API_ADDR + "/api/network/" + this.networkId,
                this.networkToUpdate,
                {
                  headers: { Authorization: tokenStore.getToken() }
                }
              )
              .then(res => {
                if (res.data.success) {
                  this.$emit("saved",this.$t('Networks.Alert.success-update'));
                }
              })
              .catch(err => {
                this.$emit("error", err.response.data.errorMessage);
              });
          } else {
            this.$emit("error", this.$t('Networks.Alert.form-error'));
          }
          break;
      }
    }
  }
};
</script>


